// @generated by protoc-gen-es v2.10.2 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file petri/service.proto (package petri, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file petri/service.proto.
 */
export const file_petri_service = /*@__PURE__*/
  fileDesc("ChNwZXRyaS9zZXJ2aWNlLnByb3RvEgVwZXRyaSIXChVHZXRDdXJyZW50VXNlclJlcXVlc3QiPQoWR2V0Q3VycmVudFVzZXJSZXNwb25zZRISCgp1c2VyX2VtYWlsGAMgASgJEg8KB3VzZXJfaWQYBCABKAkyXwoMUGV0cmlTZXJ2aWNlEk8KDkdldEN1cnJlbnRVc2VyEhwucGV0cmkuR2V0Q3VycmVudFVzZXJSZXF1ZXN0Gh0ucGV0cmkuR2V0Q3VycmVudFVzZXJSZXNwb25zZSIAYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * Describes the message petri.GetCurrentUserRequest.
 * Use `create(GetCurrentUserRequestSchema)` to create a new message.
 */
export const GetCurrentUserRequestSchema = /*@__PURE__*/
  messageDesc(file_petri_service, 0);

/**
 * Describes the message petri.GetCurrentUserResponse.
 * Use `create(GetCurrentUserResponseSchema)` to create a new message.
 */
export const GetCurrentUserResponseSchema = /*@__PURE__*/
  messageDesc(file_petri_service, 1);

/**
 * @generated from service petri.PetriService
 */
export const PetriService = /*@__PURE__*/
  serviceDesc(file_petri_service, 0);

